import { downloadBinary, queryOrThrow } from "@rootreeweb/js-lib";

import type { IAjaxObj } from "../types.js";

declare const RTAdminAjax: IAjaxObj;

/** Initializes the colour swatch generator page. */
export function initColours(): void {
	const swatchButton = document.getElementById(
		"rt-colour-swatch-generator-button",
	);
	swatchButton?.addEventListener("click", () => {
		void handleClick();
	});
}

/** Handles the click event for the colour swatch generator button. */
async function handleClick() {
	const nonceElement = queryOrThrow(
		"#rt-colour-swatch-generator-nonce",
		HTMLInputElement,
	);
	const nonce = nonceElement.value;

	const response = await fetch(RTAdminAjax.ajaxurl, {
		body: `action=colours_get_pallet&_wpnonce=${nonce}`,
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		method: "POST",
	});
	if (!response.ok) {
		console.error("Failed to get ASE.");
		return;
	}
	const arrayBuffer = await response.arrayBuffer();
	downloadBinary("rootree-colours.ase", arrayBuffer);
}
